<div class="grid formgrid" [formGroup]="state.form">
    <div class="field col-12">
        <label for="treatmentMethod" class="block text-900 font-medium mb-2">
            Treatment Method <span style="color: red;">*</span>
        </label>
        <p-dropdown [style]="{width:'100%'}" formControlName="treatmentMethodId" [options]="state.treatmentMethods"
            optionLabel="displayName" optionValue="id" />
    </div>

    <div class="field col-6">
        <label for="startDate" class="block text-900 font-medium mb-2">
            Start Date <span style="color: red;">*</span>
        </label>
        <p-calendar appendTo="body" formControlName="startDate" [showIcon]="true" inputId="startDate"
            [style]="{width:'100%'}" />
    </div>

    <div class="field col-6">
        <label for="endDate" class="block text-900 font-medium mb-2">
            End Date
        </label>
        <p-calendar appendTo="body" formControlName="endDate" [showIcon]="true" inputId="endDate"
            [style]="{width:'100%'}" placeholder="Ongoing"
            [minDate]="crudMode === 'end' ? getTodaysDate() : state.form.getRawValue().startDate" />
    </div>

    <p-divider class="w-full" />

    <div class="field col-12 mb-0 mt-3">
        <p-button label="Save Treatment" icon="pi pi-check" type="submit" [disabled]="state.form.invalid"
            (click)="submitForm()" styleClass="w-full">
        </p-button>
    </div>
</div>